import { render } from "./InputRadioSwitch.vue?vue&type=template&id=438a3870&scoped=true"
import script from "./InputRadioSwitch.vue?vue&type=script&lang=js"
export * from "./InputRadioSwitch.vue?vue&type=script&lang=js"

import "./InputRadioSwitch.vue?vue&type=style&index=0&id=438a3870&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438a3870"]])

export default __exports__